export default "__VITE_ASSET__CqyBDWTP__"